<template>
  <section>
    <HeaderBar :my-title="myHeader" :is-prev="true"></HeaderBar>
    
    <ul class="problem-list">
      <li v-for="(item,index) in problemList" @click="getProblem(index);countNumber(2,index+1)" :class='{active:index===number}'>{{item}}</li>
      
    </ul>
    <div class="main">
      <h6>{{problemCon.faqName}}</h6>
      <router-link  tag="div" v-for="(item,index) in problemCon.urgentData" 
      :to="{path: '/commonSec/problemDetail', query:{myIdx:item.idx}}" class="urgentPro">{{item.title}}</router-link>

      <router-link  tag="div" v-for="(item,index) in problemCon.commonData" 
      :to="{path: '/commonSec/problemDetail', query:{myIdx:item.idx}}" class="commonPro">{{item.title}}</router-link>
       
      
    </div>
    
    <FooterBar></FooterBar>
  </section>
  
  

</template>

<script>
import FooterBar from './base/footer'
import HeaderBar from './base/header'
export default {
  components: {
    HeaderBar,
    FooterBar
  },
  name: 'commonSec',
  created: function () {
    this.getProblem(0)
  },
  data () {
    return {
      problemList:["登录","充值","装备","安全"],
      problemCon: {},
      number:0,
      myHeader:"彩虹客服",
      isPrevShow:false
    }
  },
  methods:{
    getProblem(num){
      this.number= num;
      var _this = this 
      this.$http.get('/api/faq/list?type='+(num+1)+'')
        .then((response)=> {
        
          _this.problemCon = response.data.data

           
        })
        .catch((error) =>{
          console.log(error);
        });
        
      },
      tabProblemList(){


      }


    
  }
}
</script>


<style scoped>
.problem-list{font-size: 0.3rem;color: #999999;margin-top: 0.35rem;height: 1rem;overflow:hidden;}
.problem-list li{float: left;margin-right: 0.54rem;height: 100%;}
.problem-list li:nth-of-type(1){margin-left: 1.71rem}
.problem-list .active{color: #000;background: url(../assets/problem-list.png) no-repeat center 0.58rem;background-size: 0.5rem 0.08rem;}
.main h6{font-size:0.32rem;margin: 0rem 0 0.5rem 0rem;font-weight: normal;border-top: 0.14rem solid #e6e6e6;padding-left: 0.66rem;padding-top: 0.42rem}
.main .urgentPro{font-size: 0.3rem;width: 4.65rem;padding: 0 1rem;height: 1rem;line-height: 1rem;text-align: center;color: #fff;background: #e5004f;margin-left: 0.45rem;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;border: 1px solid #d7d7d7;margin-top: 0.24rem;}
.main .commonPro{background: #fafafa;border: 1px solid #d7d7d7;color: #999;margin-top: 0.24rem;
font-size: 0.3rem;width: 4.65rem;padding: 0 1rem;height: 1rem;line-height: 1rem;text-align: center;margin-left: 0.45rem;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;}
.main{padding-bottom: 1.6rem}
</style>



// WEBPACK FOOTER //
// src/components/commonSec.vue